module.exports = __webpack_public_path__ + "img/Thank-you-for-REGISTERATION-en.c2ed213.png";